import { Box, Button, Typography, useMediaQuery, useTheme } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckIcon from "@mui/icons-material/Check";
import imgDictamen from "@assets/img/iconTap/dicatamen.svg";
import imgEmpresa from "@assets/img/iconTap/empresa.svg";
import imgAval from "@assets/img/iconTap/aval.svg";
import imgPropietario from "@assets/img/iconTap/propietario.svg";
import imgGarantia from "@assets/img/iconTap/garantia.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { BofuTabCode, BofuTabItem } from "@interfaces/response";
import { useEffect, useState } from "react";

interface ButtonTabProps {
  bofuTab: BofuTabItem;
  // code: BofuTabCode;
  // disabled?: boolean;
  onClickDisabled?: () => void;
  // status?: BofuTabStatus;
}

interface ButtonTabConfig {
  label: string;
  icon: string;
}

const configurations: Record<BofuTabCode, ButtonTabConfig> = {
  TBDIC: {
    label: "Dictamen",
    icon: imgDictamen,
  },
  TBGRT: {
    label: "Garantía",
    icon: imgGarantia,
  },
  TBEMP: {
    label: "Empresa",
    icon: imgEmpresa,
  },
  TBAVL: {
    label: "Aval",
    icon: imgAval,
  },
  TBPRO: {
    label: "Propietario",
    icon: imgPropietario,
  },
  TBREP: {
    label: "Representante",
    icon: imgPropietario,
  },
};

const STATUS_VARIANTS = {
  validado: {
    color: "#01A388",
    text: "Validado",
  },
  incomplete: {
    color: "#F2704F",
    text: "Faltantes",
  },
  cargado: {
    color: "#A3D4E8",
    text: "Cargado",
  },
  no_aplica: {
    color: "#01A388",
    text: "No aplica",
  },
};

const ButtonTab = (props: ButtonTabProps) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();

  const [isSelected, setIsSelected] = useState(false);

  const RenderStatusLabel = () => {
    if (!props.bofuTab.tab_status || !STATUS_VARIANTS[props.bofuTab.tab_status]) {
      return null;
    }

    const status_variant = STATUS_VARIANTS[props.bofuTab.tab_status];

    if (status_variant) {
      return (
        <Typography color={status_variant.color} fontSize={isMobileOrTablet ? "9px" : "11px"} mt="0px" fontWeight={500}>
          {status_variant.text}
        </Typography>
      );
    }

    return null;
  };

  const RenderStatusIcon = () => {
    if (props.bofuTab.tab_status === "validado") {
      return <CheckIcon style={{ color: "#01A388", fontSize: "22px", margin: "0px", padding: "0px" }} />;
    } else if (props.bofuTab.tab_status === "incomplete") {
      return <WarningAmberIcon style={{ color: "#F2704F", fontSize: "22px", margin: "0px", padding: "0px" }} />;
    } else if (props.bofuTab.tab_status === "cargado") {
      return <CheckIcon style={{ color: "#A3D4E8", fontSize: "22px", margin: "0px", padding: "0px" }} />;
    } else if (props.bofuTab.tab_status === "no_aplica") {
      return <CheckIcon style={{ color: "#01A388", fontSize: "22px", margin: "0px", padding: "0px" }} />;
    }

    return null;
  };

  const RenderSectionIcon = () => {
    return (
      <img
        src={configurations[props.bofuTab.code].icon}
        alt="Icono"
        className="icon"
        style={{
          transition: "filter 0.3s",
          marginTop: "5px",
          filter: props.bofuTab.is_disabled
            ? "brightness(0) saturate(100%) invert(75%)"
            : isSelected
            ? "brightness(0) invert(1)"
            : "",
        }}
      />
    );
  };

  const RenderButton = () => {
    const selectedConfig = configurations[props.bofuTab.code];

    if (!selectedConfig) {
      return null;
    }

    return (
      <Button
        onClick={() => {
          navigate(props.bofuTab.url);
        }}
        disabled={props.bofuTab.is_disabled}
        sx={{
          backgroundColor: isSelected ? theme?.palette?.otherColors?.tabBackground : "transparent",
          color: isSelected ? theme?.palette?.otherColors?.tabText : theme?.palette?.primary?.dark,
          borderRadius: "8px",
          textTransform: "none",
          display: "flex",
          flexDirection: isMobileOrTablet ? "column" : "row",
          alignItems: "center",
          justifyContent: "center",
          height: "80px",
          width: {
            xs: "100%",
            sm: "100%",
          },
          fontSize: "14px",
          linehtHeig: "16px",
          fontWeight: 500,
          "&:hover": {
            backgroundColor: theme?.palette?.otherColors?.tabBackground,
            color: theme?.palette?.otherColors?.tabText,
            "& .icon": {
              filter: "brightness(0) invert(1)",
            },
          },
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          height="100%"
        >
          <RenderStatusIcon />
          {selectedConfig.label}
          {props.bofuTab.tab_status === undefined && <RenderSectionIcon />}
          <RenderStatusLabel />
        </Box>
      </Button>
    );
  };

  useEffect(() => {
    // validar si el tab esta activo
    const is_selected = location.pathname.includes(props.bofuTab.url);
    setIsSelected(is_selected);
  }, [location.pathname, props.bofuTab.url]);

  return <RenderButton />;
};

export default ButtonTab;
